import { useActiveSection } from "../hooks/active-section";
import { useLocale } from "../stores/locale";

const SECTION_IDS = ["about", "testimony", "portfolio", "contact"] as const;

export function Menu() {
  const t = useLocale((state) => state.locale);
  const currentPage = useActiveSection(SECTION_IDS);

  return (
    <ul className="flex justify-between">
      <li>
        <MenuItemLink href="#about" isCurrent={currentPage === "about"}>
          {t.about}
        </MenuItemLink>
      </li>
      <li>
        <MenuItemLink href="#portfolio" isCurrent={currentPage === "portfolio"}>
          {t.portfolio}
        </MenuItemLink>
      </li>
      <li>
        <MenuItemLink href="#contact" isCurrent={currentPage === "contact"}>
          {t.contact}
        </MenuItemLink>
      </li>
    </ul>
  );
}

function MenuItemLink({
  href,
  children,
  isCurrent,
}: {
  href: string;
  children: React.ReactNode;
  isCurrent?: boolean;
}) {
  return (
    <a
      className={`uppercase hover:font-bold ${isCurrent ? "font-bold" : ""}`}
      href={href}
    >
      {children}
    </a>
  );
}
